import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { useLang } from '@shapeable/ui';
import { classNames } from '@shapeable/utils';
import { MetricLayout } from '../entities/metric-layout';
import { IndicatorLayoutComponentProps } from '../../types';
import { MetricValue } from '../elements/metric-value';
import { EntityTotalCircleTrailBarChart } from '../entities/entity-total-circle-trail-bar-chart';
import { CONTENT_BACKGROUND, OCEAN_BLUE } from '../../theme';
import { Indicator, IndicatorResult } from '@shapeable/kelp-forest-alliance-types';
const cls = classNames('indicator-layout-trail-bar-chart');

export type IndicatorLayoutTrailBarChartProps = IndicatorLayoutComponentProps & {
};

export const IndicatorLayoutTrailBarChartDefaultProps: Omit<IndicatorLayoutTrailBarChartProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    box-sizing: border-box;
    padding: ${theme.UNIT(6)} 0 ${theme.UNIT(2)} 0;
  `,
});

const ValueStyles = breakpoints({
  base: css`
  
  `,
});

const ChartStyles = breakpoints({
  base: css`
    width: 100%;
    margin-top: ${theme.UNIT(4)};
  `,
});


// -------- Components -------->

const My = {
  Container: styled(MetricLayout)<ContainerProps>`${ContainerStyles}`,
    Value: styled(MetricValue)`${ValueStyles}`,
    Chart: styled(EntityTotalCircleTrailBarChart)`${ChartStyles}`,
};

export const IndicatorLayoutTrailBarChart: Shapeable.FC<IndicatorLayoutTrailBarChartProps> = (props) => {
  const { className, children, entity } = props;
  const t = useLang();

  const { result } = entity || {};
  const { entityTotals = [], supportingIndicatorResults = [] } = result || {};
  const hasSupprtingIndicators = !!supportingIndicatorResults.length;
  const hasEntityTotals = !!entityTotals.length;
  const entityTotalsCount = entityTotals.map(item => item.total || 0).reduce((a, b) => a + b, 0);

  const showChart = hasEntityTotals && entityTotalsCount > 0;

  return (
    <My.Container 
      showContent 
      entity={entity} 
      ratio={showChart ? 2 : 1} 
      stretch={showChart} 
      hasPadding={false}
      className={className}
      >
      {
        hasSupprtingIndicators && (
          supportingIndicatorResults.map(supportInd => {
            const { indicator } = supportInd as IndicatorResult & { indicator: Indicator };
            const suffix = indicator?.suffixLabel || indicator?.title || indicator?.unit?.shorthand;
            return (
              <My.Value suffix={t(suffix)} value={supportInd?.numericValue} />
            )
          })
        )
      }
      {
        showChart && (
          <My.Chart
            color={OCEAN_BLUE}
            backgroundColor={CONTENT_BACKGROUND} 
            items={entityTotals} 
          />
        )
      }

    </My.Container>
  )
};

IndicatorLayoutTrailBarChart.defaultProps = IndicatorLayoutTrailBarChartDefaultProps;
IndicatorLayoutTrailBarChart.cls = cls;